<div *ngIf="currentVraag" [ngClass]="status" [class.ols-change-question]="isWijzigen" [id]="geefIpoView()">
  <div *ngIf="header || headerIcon" class="ols-summary-header">{{header}}
    <div *ngIf="headerIconSvg()" [ngStyle]="{'background-image': headerIconUrl}" class="ols-header-icon"></div>
    <ng-content select="app-vraagboom-summary-group"></ng-content>
  </div>

  <div class="ols-groep-container">
    <ng-container *ngFor="let groep of vraagGroepen">
      <ng-container *ngIf="groep.id === currentVraag.groep_id || currentVraag.control === controltype.Summary">
        <div class="ols-groep" [ngClass]="summaryGroep(groep)">
          <div *ngIf="groep.resultaten.length > 0" class="ols-vraag-container">
            <ng-container *ngIf="groep.id !== currentVraag.groep_id">
              <app-vraag-control-summary [status]="status" [currentVraag]="currentVraag"
                [antwoordResultaten]="filterInfo(groep.resultaten)" (wijzigenClicked)="wijzigenVraag($event)">
              </app-vraag-control-summary>
            </ng-container>
            <ng-container *ngIf="groep.id === currentVraag.groep_id">
              <div *ngFor="let resultaat of groep.resultaten" class="ols-groep-vraag"
                [ngClass]="{'show-groep-vraag': showGroepVraag(resultaat), 'ols-hasheader-icon': headerIconSvg()}">
                <div *ngIf="resultaat.vraag.id === currentVraag.id" #currentVraag></div>
                <app-vraag-control *ngIf="resultaat.vraag.messageVraag" [vraag]="resultaat.vraag.messageVraag">
                </app-vraag-control>
                <app-vraag-control [vraag]="resultaat.vraag" [antwoordResultaat]="resultaat"
                  (antwoordResultaatChange)="onAntwoordResultaatChange(resultaat.vraag, resultaat)"
                  [isCurrentVraag]="resultaat.vraag.id === currentVraag.id"></app-vraag-control>
              </div>
            </ng-container>
          </div>
          <ng-container *ngIf="groep.id === currentVraag.groep_id">
            <div *ngIf="currentVraag.control === controltype.SuccesSchadecoach" [attr.data-schadecoach]="idSchadecoach" [attr.data-schadecoach-qs]="idsSchadecoach"></div>
            <div class="stickyfooter">
              <ng-content select="[error-container]"></ng-content>
              <div *ngIf="!vragenreeksIsFinal()" class="vraag__actions"
                [ngClass]="{'ols-3buttons': volgendeVraagExtraButtonVersturen()}">
                <div class="buttons-container buttons-left">
                  <a class="button-link" [id]="geefMeetidVorige()" (click)="clickVorige(groep)"
                    [ngClass]="{'vorige': bepaalHasTerug}">
                    {{geefTekstVorigeKnop()}}
                  </a>
                </div>
                <div class="buttons-container buttons-right">
                  <a *ngIf="!isEindeProces(currentVraag)" class="button button--schade has-ripple volgende" tabindex="0"
                    (keyup.enter)="opslaanVraag(currentVraag, getResultaatCurrentGroep(groep, currentVraag))"
                    (click)="opslaanVraagIfValid(!canSubmitResultaat(getResultaatCurrentGroep(groep, currentVraag)), currentVraag, getResultaatCurrentGroep(groep, currentVraag))"
                    [id]="geefMeetidVolgende(groep, currentVraag)">{{geefTekstVolgendeKnop(groep, currentVraag)}}</a>
                  <a *ngIf="volgendeVraagExtraButtonVersturen()" class="button button--outline has-ripple"
                    (click)="opslaanVraagEnVersturen()"
                    [id]="geefMeetidButtonVersturen(currentVraag)">{{geefTekstButtonVersturen()}}</a>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div class="ols-eindtekst" [innerHTML]="currentVraag.huidige_stap"></div>
  <div class="ols-melding"><ng-content select="[melding-container]"></ng-content></div>
</div>